import { React, useEffect} from "react";
import {Navigate, useParams} from 'react-router-dom';
import axios from 'axios';
import Menu from "../components/menu/Menu";
import Wallet from "../components/wallet/Wallet";
import {Container} from 'react-bootstrap';
import Verify from "../components/verify/Verify"
import "../generales.css";
// import { trackPromise } from 'react-promise-tracker';

const WalletMain = () => {

    const params = useParams();
    var idwal = null;
    
    if(params){
        idwal = params.idwal
    }

    // if(!sessionStorage.getItem('userData')){
    //     return <Navigate to="/"  />;
    // }
    // else{
    //     Verify()
    // }

    const onButtonClick = () => {
        const pdfUrl = "Sample.pdf";
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "your file name.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    

    const getData= async () => {
        
        let ud = sessionStorage.getItem('userData');
        let userData = JSON.parse(ud);

        const instance = axios.create({
                baseURL: '',
                timeout: 5000,
                headers: {'content-type': 'application/vnd.apple.pkpass', 'Authorization': 'Bearer '+userData.access_token}
                });
        
        //trackPromise(
            await instance.get('../api/passkit')
            .then(response => {
                // setItems(response.data)
                console.log(response.data)
                return(response.data)
            })
        //)
    }

    useEffect(()=>{
        getData()
    },[])

    
    return(
        <>
            <Menu />
            <Container fluid className="container_webcam">
                {/* <Wallet id={idwal} /> */}
            </Container>
        </>
    )
};

export default WalletMain;
